export const ORDERS_STATUS = {
	PAID: 'paid',
	AWAITING_PAYMENT: 'awaiting_payment',
	PENDING: 'pending',
};

export enum ERefundStatus {
	REFUNDED = 'refunded',
	PARTIAL_REFUND = 'partial_refund',
	NOT_REFUNDED = 'not_refunded',
}
